"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 9px;\n  color: ", ";\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 16px;\n  height: 16px;\n  appearance: none;\n  outline: none;\n  border: none;\n  border-radius: 50%;\n"], ["\n  position: relative;\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 9px;\n  color: ", ";\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 16px;\n  height: 16px;\n  appearance: none;\n  outline: none;\n  border: none;\n  border-radius: 50%;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button = _styledComponents2.default.button.withConfig({
  displayName: "PopoverButton__Button",
  componentId: "sc-1f372cy-0"
})(_templateObject, _buoyTheme.fontFamily, _buoyTheme.fontWeight.Light, _buoyTheme.colors.neutralDarkest, _buoyTheme.colors.neutralLightest);

var PopoverButton = function PopoverButton(_ref) {
  var onClick = _ref.onClick,
      buttonRef = _ref.buttonRef;
  return _react2.default.createElement(
    Button,
    { type: "button", onClick: onClick, innerRef: buttonRef, "aria-hidden": true, tabIndex: "-1" },
    "?"
  );
};

exports.default = PopoverButton;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-popover/dist/PopoverButton.js
// module id = 435
// module chunks = 168707334958949